import styles from './SeparatorV8.module.scss';

import clsx from 'clsx';
import React from 'react';

interface SeparatorProps
  extends Omit<React.HTMLProps<HTMLDivElement>, 'children'> {
  disabled?: boolean;
  active?: boolean;
}

export function SeparatorV8(props: SeparatorProps) {
  const { className, disabled, active, ...rest } = props;

  return (
    <div
      className={clsx(styles.wrapper, !disabled && styles.enabled)}
      {...rest}
    >
      <div
        className={clsx(styles.separator, className, active && styles.active)}
      />
    </div>
  );
}
